import appClient from "../../common/services/AppClient";
import { v4 as uuid } from "uuid";
import { endpoints } from "../../../config";
import {
    WbAction,
    WbActivity,
    WbBackendAssociation,
    WbFact,
    WbFactValue,
    WbCaseSummary,
    WbDocument,
    WbSubject,
    WbSubjectsListResponse,
    WbTask,
    ContractStage,
} from "../types/WbTypes";

export default class WorkbenchService {
    async changeContractStage(
        subjectId: string,
        stage: ContractStage,
        expectedVersion: number,
    ) {
        return appClient.post<WbSubject>(
            `${endpoints.tasksUrl}workbench/subjects/${encodeURIComponent(subjectId)}/contract-stage`,
            { stage, expectedVersion },
        );
    }

    async fetchBackendAssociations(subjectId: string) {
        return appClient.get<WbBackendAssociation[]>(
            `${endpoints.tasksUrl}workbench/subjects/${encodeURIComponent(subjectId)}/backend-associations`,
        );
    }
    async withdrawBackendAssociation(
        subjectId: string,
        id: string,
        reason: string,
    ) {
        return appClient.post<void>(
            `${endpoints.tasksUrl}workbench/subjects/${encodeURIComponent(subjectId)}/backend-associations/${encodeURIComponent(id)}/withdraw`,
            { reason },
        );
    }

    async reviewSubjectFact(
        subjectId: string,
        field: string,
        action: "Confirm" | "Correct" | "Clear" | "Reject" | "Restore",
        value?: string,
        evidenceId?: string,
        details?: WbFactValue,
        reason?: string,
    ) {
        return appClient.post<WbFact[]>(
            `${endpoints.tasksUrl}workbench/subjects/${encodeURIComponent(subjectId)}/facts/${encodeURIComponent(field)}/review`,
            { action, value, evidenceId, details, reason, requestId: uuid() },
        );
    }
    async searchSubjects(query: string) {
        const url = `${endpoints.tasksUrl}workbench/subjects?searchTerm=${encodeURIComponent(query)}&page=1&pageSize=10&includeArchived=false`;
        const response = await appClient.get<WbSubjectsListResponse>(url);
        return response;
    }

    async fetchSubjectFacts(subjectId: string) {
        return appClient.get<WbFact[]>(
            `${endpoints.tasksUrl}workbench/subjects/${encodeURIComponent(subjectId)}/facts`,
        );
    }

    async fetchSubject(subjectId: string) {
        const url = `${endpoints.tasksUrl}workbench/subjects/${encodeURIComponent(subjectId)}`;
        const response = await appClient.get<WbSubject>(url);
        return response;
    }

    async fetchSubjectTasks(subjectId: string) {
        const url = `${endpoints.tasksUrl}workbench/subjects/${encodeURIComponent(subjectId)}/tasks`;
        const response = await appClient.get<WbTask[]>(url);
        return response;
    }

    async fetchSubjectDocuments(subjectId: string) {
        const url = `${endpoints.tasksUrl}workbench/subjects/${encodeURIComponent(subjectId)}/documents`;
        const response = await appClient.get<WbDocument[]>(url);
        return response;
    }

    async fetchSubjectActions(subjectId: string) {
        const url = `${endpoints.tasksUrl}workbench/subjects/${encodeURIComponent(subjectId)}/actions`;
        const response = await appClient.get<WbAction[]>(url);
        return response;
    }

    async fetchSubjectActivity(subjectId: string) {
        return appClient.get<WbActivity[]>(
            `${endpoints.tasksUrl}workbench/subjects/${encodeURIComponent(subjectId)}/activity`,
        );
    }

    async fetchSubjectCaseSummary(subjectId: string) {
        const url = `${endpoints.tasksUrl}workbench/subjects/${encodeURIComponent(subjectId)}/case-summary`;
        const response = await appClient.get<WbCaseSummary>(url);
        return response;
    }
}
